// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__SmdPX","list":"styles_list__2xuSs"};